module.exports = __webpack_public_path__ + "img/logoleche.0302e685.jpg";